import { render, staticRenderFns } from "./FloatingPhoneButton.vue?vue&type=template&id=eca638e0&scoped=true"
import script from "./FloatingPhoneButton.vue?vue&type=script&lang=js"
export * from "./FloatingPhoneButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingPhoneButton.vue?vue&type=style&index=0&id=eca638e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca638e0",
  null
  
)

export default component.exports